import { Model } from '@vuex-orm/core'
import JourneyLeg from '@models/JourneyLeg'
import Station from '@models/Station'
import Booking from '@models/Booking'

export default class Journey extends Model {
  static entity = 'journeys'

  static fields() {
    return {
      id: this.increment(),

      booking_id: this.attr(),
      origin_station_id: this.attr(),
      destination_station_id: this.attr(),

      ref: this.attr(),
      direction: this.attr('outward'),
      position: this.attr(''),
      realtime_arrival: this.attr(''),
      realtime_classification: this.attr('ONTIME'),
      realtime_departure: this.attr(''),
      scheduled_arrival: this.attr(''),
      scheduled_departure: this.attr(''),
      duration: this.attr(''),
      changes: this.attr(''),
      outbound_time_type: this.attr(''),
      min_change_time: this.attr(''),
      bespoke: this.boolean(false),
      replanned: this.attr(false),
      extraJourney: this.attr(false),
      can_be_replanned: this.attr(false),

      legs: this.hasMany(JourneyLeg, 'journey_id'),
      booking: this.belongsTo(Booking, 'booking_id'),
      origin_station: this.belongsTo(Station, 'origin_station_id'),
      destination_station: this.belongsTo(Station, 'destination_station_id'),

      active_journey: this.attr(false),
      active_journey_id: this.attr(''),
      journey_planner_response: this.attr([]),
      parent_journey_id: this.attr(''),
    }
  }

  static mapSingleToOutward(journey) {
    if (journey.direction === 'single') {
      journey.direction = 'outward'
    }
  }

  static beforeCreate(journey) {
    this.mapSingleToOutward(journey)
  }

  static beforeInsert(journey) {
    this.mapSingleToOutward(journey)
  }
}
